export default "__VITE_ASSET__fXNc9taO__"